import React from "react";
import LanguageHelper from "../../../helpers/LanguageHelper";
import Request from "../../../helpers/Request";
import TableEntryModal from "../../../components/Modal/TableEntryModal";
import showSnackbar from "../../../components/Utils/showSnackbar";
import IsgProfessionalForm from "./IsgProfessionalForm";
import { ISG_PROFESSIONALS_URL } from "./FetchData";
import {
  buildCreatePayload,
  buildUpdatePayload,
  emptyForm,
  toFormValues,
  validateForm,
} from "./isgProfessionalPayload";

export const entryUrl = (documentType, tcNo) =>
  ISG_PROFESSIONALS_URL +
  "/" +
  encodeURIComponent(documentType) +
  "/" +
  encodeURIComponent(tcNo);

export default function IsgProfessionalModal({
  modal,
  setModal,
  row,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  tableRef,
  options,
  reloadLimit,
}) {
  const language = LanguageHelper.getLanguage();
  const isEdit = Boolean(row);

  const [form, setForm] = React.useState(emptyForm);
  const [errors, setErrors] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setForm(row ? toFormValues(row) : emptyForm);
    setErrors({});
  }, [row, modal]);

  const handleCloseModal = () => {
    setModal(false);
  };

  const submit = async () => {
    const validationErrors = validateForm(form, row);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    setLoading(true);
    const resp = isEdit
      ? await Request(
          "put",
          entryUrl(row.documentType, row.tcNo),
          buildUpdatePayload(form)
        )
      : await Request("post", ISG_PROFESSIONALS_URL, buildCreatePayload(form));
    showSnackbar(
      resp,
      setSeverity,
      setSnackbarMessage,
      setSnackbar,
      isEdit ? language.etc.updated : language.etc.added,
      tableRef
    );
    setLoading(false);
    if (resp?.status === 200) {
      reloadLimit();
      handleCloseModal();
    }
  };

  return (
    <TableEntryModal modal={modal} handleCloseModal={handleCloseModal}>
      <IsgProfessionalForm
        form={form}
        setForm={setForm}
        errors={errors}
        row={row}
        loading={loading}
        options={options}
        onSubmit={submit}
      />
    </TableEntryModal>
  );
}
